import(/* webpackMode: "eager" */ "/vercel/path0/src/app/quests/page.tsx");
